module.exports = __webpack_public_path__ + "img/mouse_illustration_mobile.5fc9f56e.png";